import { generateTestId } from "@client-shared";

export const setFinanceSettingsViewTestId = (identifier: string): string =>
  generateTestId("FinanceSettingsView", identifier);

// Container and header
export const setFinanceSettingsViewContainerTestId = (): string =>
  setFinanceSettingsViewTestId("container");

export const setFinanceSettingsViewTitleTestId = (): string =>
  setFinanceSettingsViewTestId("title");

export const setFinanceSettingsViewSubtitleTestId = (): string =>
  setFinanceSettingsViewTestId("subtitle");

// VAT Validation Card
export const setFinanceSettingsViewVatCardTestId = (): string =>
  setFinanceSettingsViewTestId("vat-card");

export const setFinanceSettingsViewVatCardTitleTestId = (): string =>
  setFinanceSettingsViewTestId("vat-card-title");

export const setFinanceSettingsViewVatCardDescriptionTestId = (): string =>
  setFinanceSettingsViewTestId("vat-card-description");

export const setFinanceSettingsViewGermanyVatSectionTestId = (): string =>
  setFinanceSettingsViewTestId("germany-vat-section");

export const setFinanceSettingsViewNetherlandsVatSectionTestId = (): string =>
  setFinanceSettingsViewTestId("netherlands-vat-section");

// Export Templates Card
export const setFinanceSettingsViewExportCardTestId = (): string =>
  setFinanceSettingsViewTestId("export-card");

export const setFinanceSettingsViewExportCardTitleTestId = (): string =>
  setFinanceSettingsViewTestId("export-card-title");

export const setFinanceSettingsViewExportCardDescriptionTestId = (): string =>
  setFinanceSettingsViewTestId("export-card-description");

export const setFinanceSettingsViewExportFormatLabelTestId = (): string =>
  setFinanceSettingsViewTestId("export-format-label");

export const setFinanceSettingsViewDateFormatLabelTestId = (): string =>
  setFinanceSettingsViewTestId("date-format-label");

export const setFinanceSettingsViewNumberFormatLabelTestId = (): string =>
  setFinanceSettingsViewTestId("number-format-label");

export const setFinanceSettingsViewIncludeInExportsTestId = (): string =>
  setFinanceSettingsViewTestId("include-in-exports");

export const setFinanceSettingsViewTaxDetailsOptionTestId = (): string =>
  setFinanceSettingsViewTestId("tax-details-option");

export const setFinanceSettingsViewLineItemsOptionTestId = (): string =>
  setFinanceSettingsViewTestId("line-items-option");

// Defaults Card
export const setFinanceSettingsViewDefaultsCardTestId = (): string =>
  setFinanceSettingsViewTestId("defaults-card");

export const setFinanceSettingsViewDefaultsCardTitleTestId = (): string =>
  setFinanceSettingsViewTestId("defaults-card-title");

export const setFinanceSettingsViewDefaultsCardDescriptionTestId = (): string =>
  setFinanceSettingsViewTestId("defaults-card-description");

export const setFinanceSettingsViewDefaultCountryLabelTestId = (): string =>
  setFinanceSettingsViewTestId("default-country-label");

export const setFinanceSettingsViewDefaultDateRangeLabelTestId = (): string =>
  setFinanceSettingsViewTestId("default-date-range-label");

export const setFinanceSettingsViewDefaultStatusLabelTestId = (): string =>
  setFinanceSettingsViewTestId("default-status-label");

// Phase Configuration Card
export const setFinanceSettingsViewPhasesCardTestId = (): string =>
  setFinanceSettingsViewTestId("phases-card");

export const setFinanceSettingsViewPhasesCardTitleTestId = (): string =>
  setFinanceSettingsViewTestId("phases-card-title");

export const setFinanceSettingsViewPhasesCardDescriptionTestId = (): string =>
  setFinanceSettingsViewTestId("phases-card-description");

export const setFinanceSettingsViewPhase1RowTestId = (): string =>
  setFinanceSettingsViewTestId("phase1-row");

export const setFinanceSettingsViewPhase1BadgeTestId = (): string =>
  setFinanceSettingsViewTestId("phase1-badge");

export const setFinanceSettingsViewPhase2RowTestId = (): string =>
  setFinanceSettingsViewTestId("phase2-row");

export const setFinanceSettingsViewPhase2BadgeTestId = (): string =>
  setFinanceSettingsViewTestId("phase2-badge");

// Save Button
export const setFinanceSettingsViewSaveButtonTestId = (): string =>
  setFinanceSettingsViewTestId("save-button");
